"use client";

import { openModal } from "@decibeltrade/web-core/modal";
import dynamic from "next/dynamic";

const PwaInstallModalContent = dynamic(
  () => import("./pwa-install-modal-content").then((m) => m.PwaInstallModalContent),
  { ssr: false },
);

export const openPwaInstallModal = () => {
  openModal({
    id: "pwa-install",
    renderContent: (props) => <PwaInstallModalContent {...props} />,
  });
};
